import { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TextInput, TouchableOpacity } from 'react-native';

import { useGetAllEngineersQuery } from '@store/services/api/user-api';
import GlobalStyle from '../../../../../constants/GlobalStyle';
import moment from 'moment';
import { Picker } from '@react-native-picker/picker';
import DateTimePicker from '@web/components/navigation/controls/DateTimePicker';
import { Foundation, SimpleLineIcons } from '@expo/vector-icons';
import { erstrApi } from '@store/services/api/erstr-api';
import { PagedTableDto } from '@store/services/api/base-api';
import { LoadingIndicator } from '@web/components/navigation/controls/LoadingIndicator';
import { Basket, BasketIcon } from '@web/components/Basket';
import { DataTable } from 'react-native-paper';
import { useSelector } from 'react-redux';
import { ReportableService } from '@store/services/reportable/reportable.service';
import { DataTableHeader } from '@web/table/DataTableHeader';
import React from 'react';

export default function EngineerReportsScreen({navigation}: {navigation: any}) {
  const { data: engineers } = useGetAllEngineersQuery(null);

  const [engineerId, setEngineerId] = useState("");
  const [dateRange, setDateRange] = useState("");
  const [startDate, setStartDate] = useState(moment().add(-1, 'months').toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [jobNumber, setJobNumber] = useState("");
  const [jobType, setJobType] = useState(-1);

  const [page, setPage] = useState<number>(0);
  const [sortedColumn, setSortedColumn] = React.useState<string>("jobNumber");
  const [sortedColumnAscending, setSortedColumnAscending] = React.useState<boolean>(true);

  const [trigger, inspectionResult] = erstrApi.useLazyGetEngineerReportsQuery();

  // useEffect(() => {
  //   loadTable();
  // }, [page])
  useEffect(() => {
    loadTable();
  }, [page, sortedColumn, sortedColumnAscending])

  useEffect(() => {
    console.log(inspectionResult.data);
  }, [inspectionResult.data]);

  const updateDateRange = (val) => {
    setDateRange(val);

    let startDate = moment();
    const endDate = moment();
    if (val == "-1") {
      startDate = moment().add(-1, 'week');
    } else {
      startDate = moment().add(-Number.parseInt(val), 'M');
    }

    setStartDate(startDate.toDate());
    setEndDate(endDate.toDate());
  }

  const resetFilters = () => {
    setEngineerId("");
    setDateRange("");
    setStartDate(moment().add(-1, 'months').toDate());
    setEndDate(moment().toDate());
    setJobNumber("");
    setJobType(-1);
  }

  const loadTable = () => {
    var dto = new PagedTableDto(page, { 
      engineerId: engineerId,
      startDate: moment(startDate).toISOString(),
      endDate: moment(endDate).toISOString(),
      jobNumber: jobNumber,
      jobType: jobType,
    }, sortedColumn, sortedColumnAscending);
    trigger(dto);
  }

  const downloadCert = async (engineerReport) => {
    //inspection.isLoading = true;
    var reportableService = new ReportableService();
    console.log(engineerReport.id);
    var data = await reportableService.downloadERSTR(engineerReport.id);
    //inspection.isLoading = false;
    if (data != null) {
      const fileSaver = require('file-saver');
      fileSaver(data, 'Report.pdf');
    }
  }

  if (inspectionResult.isLoading) {
    return <LoadingIndicator/>
  }


  return (
    <View style={styles.container}>
      <View style={GlobalStyle.filters}>
        <View style={GlobalStyle.filters__header}>
          <Text style={GlobalStyle.filters__header__text}>Search Filters</Text>
        </View>

        <View style={GlobalStyle.filter__columns}>
          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Engineers</Text>
            <Picker
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              selectedValue={engineerId}
              onValueChange={(itemValue, itemIndex) => setEngineerId(itemValue)}>

              <Picker.Item label="All" value="" />

              { engineers != null && engineers.map((value, index) => {
                return (
                  <Picker.Item key={value.id} label={value.name} value={value.id} />
                )
              })}
            </Picker>
          </View>

          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Job #</Text>
            <TextInput
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              onChangeText={setJobNumber}
              value={jobNumber}
            />
          </View>

          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Job Type</Text>
            <Picker
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              selectedValue={jobType}
              onValueChange={(itemValue, itemIndex) => setJobType(itemValue)}>

              <Picker.Item label="All" value={-1} />
              <Picker.Item key={0} label={"ROTE"} value={0} />
              <Picker.Item key={1} label={"Servicing"} value={1} />
              <Picker.Item key={2} label={"Repair/Breakdown"} value={2} />
              <Picker.Item key={3} label={"Proof Load"} value={3} />
            </Picker>
          </View>

          <View style={GlobalStyle.column__flex}></View>
        </View>

        <View style={GlobalStyle.filter__columns}>
          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Date Range</Text>
            <Picker
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              selectedValue={dateRange}
              onValueChange={(itemValue, itemIndex) => updateDateRange(itemValue)}>

              <Picker.Item label="Predefined Date Range" value="" />
              <Picker.Item label="1 Week" value="-1" />
              <Picker.Item label="1 Month" value="1" />
              <Picker.Item label="3 Months" value="3" />
              <Picker.Item label="6 Months" value="6" />
              <Picker.Item label="12 Months" value="12" />
              
            </Picker>
          </View>

          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Start Date</Text>
            <DateTimePicker
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              onChange={setStartDate}
              value={startDate}>
            </DateTimePicker>
          </View>

          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>End Date</Text>
            <DateTimePicker
              style={[GlobalStyle.column, GlobalStyle.column__input,]} 
              onChange={setEndDate}
              value={endDate}>
            </DateTimePicker>
          </View>

          <View style={GlobalStyle.column__flex}>
            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
              <TouchableOpacity style={GlobalStyle.filter__search__button} onPress={() => loadTable()}>
                <SimpleLineIcons name="magnifier" size={16} color="white" />
              </TouchableOpacity>

              <TouchableOpacity style={GlobalStyle.filter__clear__button} onPress={() => resetFilters()}>
                <SimpleLineIcons name="ban" size={16} color="black" />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>

      <Basket/>

      <DataTable style={GlobalStyle.table}>
      <DataTableHeader
          sortedColumn={sortedColumn}
          sortedColumnAscending={sortedColumnAscending}
          onSorted={(column, ascending) => { setSortedColumn(column); setSortedColumnAscending(ascending); }}
          headers={[
            { text: 'Basket', visible: true },
            { text: 'Report', visible: true },
            { text: 'Job #', sortedName: "jobNumber", visible: true },
            { text: 'Engineer', sortedName: "engineer", visible: true },
            { text: 'Location', sortedName: "locationName", visible: true },
            { text: 'Company', sortedName: "companyName", visible: true },
            { text: 'Created', sortedName: "inspectionDate", visible: true },
            { text: 'Job Type', sortedName: "jobType", visible: true },
            
          ]}
        />
        {/* <DataTable.Header>
          <DataTable.Title>Basket</DataTable.Title>
          <DataTable.Title>Report</DataTable.Title>
          <DataTable.Title>Job #</DataTable.Title>
          <DataTable.Title>Engineer</DataTable.Title>
          <DataTable.Title>Location</DataTable.Title>
          <DataTable.Title>Company</DataTable.Title>
          <DataTable.Title>Created</DataTable.Title>
          <DataTable.Title>Job Type</DataTable.Title>
        </DataTable.Header> */}

        { inspectionResult.data?.list.map((element: any) => {
          return (
            <DataTable.Row key={element.id}>
              <DataTable.Cell>
                <BasketIcon inspectionId={element.id} serialNumber={element.jobNumber} type={"erstr"}/>
              </DataTable.Cell>
              <DataTable.Cell>
                <View style={{ flexDirection: 'row'}}>
                  <TouchableOpacity onPress={() => downloadCert(element)}><Foundation name="page-pdf" size={24} color="black" /></TouchableOpacity>
                </View>
              </DataTable.Cell>
              <DataTable.Cell>{element.jobNumber}</DataTable.Cell>
              <DataTable.Cell>{element.engineer}</DataTable.Cell>
              <DataTable.Cell>{element.locationName}</DataTable.Cell>
              <DataTable.Cell>{element.companyName}</DataTable.Cell>
              <DataTable.Cell>{element.inspectionDateFormatted}</DataTable.Cell>
              <DataTable.Cell>{element.jobTypeFormatted}</DataTable.Cell>
            </DataTable.Row>
          )
        })}
      </DataTable>

      <DataTable.Pagination
        page={page}
        numberOfPages={inspectionResult.data?.pagination.totalPages}
        onPageChange={(page) => setPage(page)} 
        //@ts-ignore
        itemsPerPage={inspectionResult.data?.pagination.pageSize}
        showFastPagination
        optionsLabel={'Rows per page'}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
    padding: 10,
  },

});
